<template>
  <div>
    <b-row class="no-gutters align-items-center">
      <b-col class="col-12 col-md-3 body__1">
        {{ fullName }}
      </b-col>
      <b-col class="col-12 col-md-3 text-muted body__2 text-md-center">
        {{ email }}
      </b-col>
      <b-col class="col-12 col-md-3 text-muted body__2 text-md-center">
        {{ subType }}
      </b-col>
      <b-col class="col-12 col-md-3 text-muted body__2 text-md-right">
        {{ branchName }}
      </b-col>
    </b-row>
    <b-row class="no-gutters align-items-center mt-2">
      <b-col class="col-12">
        <b-form-checkbox
          v-model="aiFeaturesDisabled"
          switch
          @change="onToggleAiFeatures"
        >
          <span class="text-muted body__2 ml-3">
            {{ $t("disableAiFeatures") }}
          </span>
        </b-form-checkbox>
      </b-col>
    </b-row>
    <hr class="my-3" />
  </div>
</template>

<script>
import services from "./../../services";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    branch: {
      type: Object,
    },
  },
  data() {
    return {
      aiFeaturesDisabled: !!this.user.aiFeaturesDisabled,
    };
  },
  computed: {
    fullName() {
      return this.user.firstName + " " + this.user.lastName;
    },
    email() {
      return this.user.email;
    },
    subType() {
      return (
        this.user.subType.charAt(0).toUpperCase() + this.user.subType.slice(1)
      );
    },
    branchName() {
      return (this.branch && this.branch.name) ? this.branch.name : "-";

    },
  },
  methods: {
    onToggleAiFeatures(value) {
      this.$store.commit("loader/SET_LOADER", {});
      services.UserService.updateUser(this.user._id, {
        aiFeaturesDisabled: value,
      })
        .then(() => {
          this.user.aiFeaturesDisabled = value;
          this.$store.commit("success/SET_SUCCESS_INFO", {});
        })
        .catch(() => {
          this.aiFeaturesDisabled = !value;
          this.$store.commit("error/SET_ERROR", {});
        })
        .finally(() => this.$store.dispatch("loader/close"));
    },
  },
};
</script>

<style></style>
